import React, {Fragment} from 'react'
import styles from './EditRouteDialog.scss'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {orgVisibility, userVisibility} from 'lib/visibility'

export const EDIT_ROUTE_DIALOG = 'EDIT_ROUTE_DIALOG'

export class EditRouteDialog extends React.PureComponent {
  constructor (props) {
    super(props)
    const {route} = props
    this.state = {
      title: route.name,
      description: route.description,
      visibility: route.visibility,
      savePending: false
    }
  }

  onTitleChange = (e) => {
    this.setState({title: e.target.value})
  }

  onDescriptionChange = (e) => {
    this.setState({description: e.target.value})
  }

  onVisibilityChange = (e) => {
    this.setState({visibility: parseInt(e.target.value, 10)})
  }

  saveChanges = () => {
    const {updateRoute, route, onRequestClose} = this.props
    const {title, description, visibility, savePending} = this.state
    if (savePending) { return }

    this.setState({savePending: true})
    updateRoute(route.id, {
      name: title,
      description,
      visibility
    }).then(() => {
      this.setState({savePending: false}, onRequestClose)
    })
  }

  render () {
    const {onRequestClose, route} = this.props
    const {title, description, visibility, savePending} = this.state
    const visibilityMap = route.club ? orgVisibility : userVisibility

    return (
      <ConfirmationDialog
        title={<Fragment>Editing <strong>{route.name}</strong></Fragment>}
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.saveChanges}
        confirmPending={savePending}
        confirmText='Save'
        footerHint={<a href={`/routes/${route.id}/edit`} target='_blank'>Edit Route in Planner</a>}>
        <div className={styles.EditRouteDialog}>
          <form onSubmit={e => { e.preventDefault(); this.saveChanges() }}>
            <div>
              <label htmlFor='title-input'>Title</label>
              <input id='title-input'
                type='text'
                value={title}
                onChange={this.onTitleChange} />
            </div>
            <div>
              <label htmlFor='description-input'>Description</label>
              <textarea id='description-input'
                rows='5'
                value={description}
                onChange={this.onDescriptionChange} />
            </div>
            <div>
              <label>Visibility</label>
              <select value={visibility} onChange={this.onVisibilityChange}>
                <option value='0'>{visibilityMap[0]}</option>
                <option value='1'>{visibilityMap[1]}</option>
                <option value='2'>{visibilityMap[2]}</option>
              </select>
            </div>
          </form>
        </div>
      </ConfirmationDialog>
    )
  }
}
